export function getIcon(id){
    if(id === null){
        id="erasepin"
    }
    return process.env.PUBLIC_URL+'/asset/'+id+'.svg'
}
